export default __webpack_public_path__ + "static/media/Resources.5b033072.svg";